import { FC } from 'react';
import { Control, useWatch } from 'react-hook-form';

import { AppFormattedMessage } from '../../../../../../components/app-formatted-message/index';
import { FormInput } from '../../../../../../components/input/index';
import { Company } from '../../../../../../hooks/index';
import { documentSubCategoryRequiresLinkedEvent } from '../../../../constants/document-category.constant';
import { QuickSignFormSchema } from '../../../validation/quick-sign.validation';
import { CategoryCombobox } from '../combobox/category-combobox';
import { LinkedEventCombobox } from '../combobox/linked-event-combobox';
import { SubCategoryCombobox } from '../combobox/sub-category-combobox';

export type QuickSignStepOneProps = {
  control: Control<QuickSignFormSchema>;
};

export const QuickSignStepOne: FC<QuickSignStepOneProps> = ({ control }) => {
  const { selectedCompanyId } = Company.useSelected();
  const category = useWatch({ control, name: 'stepOne.category' });
  const subCategory = useWatch({ control, name: 'stepOne.subCategory' });

  return (
    <div className="flex h-full flex-col bg-gray-100">
      <div className="flex flex-1 flex-col gap-4 overflow-y-auto rounded-b-xl border-b border-gray-300 bg-white px-6 pb-4 pt-6">
        <FormInput
          control={control}
          name="stepOne.name"
          placeholder={<AppFormattedMessage id="DOCUMENT_NAME" />}
          wrapperClassName="min-h-[56px]"
        />

        <CategoryCombobox control={control} />

        {category && <SubCategoryCombobox control={control} />}

        {selectedCompanyId && documentSubCategoryRequiresLinkedEvent(subCategory) && (
          <LinkedEventCombobox
            companyId={selectedCompanyId}
            control={control}
            subCategory={subCategory}
          />
        )}
      </div>
    </div>
  );
};
